import { StaticBaseDao } from '@/dao';
import {
    ImportContent,
    IntArray,
    ContestantBase,
    TrackingFilterRequest,
    RaceContestantWithContestantAndDeviceStatus,
    ContestantAndRaceContestantTime,
    ContestantImport,
} from '@/objects/generated';

export class ContestantDao extends StaticBaseDao {
    public static async UploadFiles(files: FormData, EventID: number): Promise<ImportContent[]> {
        return this.PostFormData(
            ImportContent,
            `Contestant/UploadFiles` +
                '?' +
                (files == undefined ? '' : `files=${files}`) +
                '&' +
                (EventID == undefined ? '' : `EventID=${EventID}`),
            files,
        );
    }
    public static async GetBaseContestants(EventID: number, IDs: IntArray): Promise<ContestantBase[]> {
        return this.BaseFetchArray(
            ContestantBase,
            `Contestant/GetBaseContestants` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            IDs,
        );
    }
    public static async GetContestantByBib(EventID: number, Bib: number): Promise<ContestantBase | null> {
        return this.BaseFetch(
            ContestantBase,
            `Contestant/GetContestantByBib` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (Bib == undefined ? '' : `Bib=${Bib}`),
            'GET',
        );
    }
    public static async GetContestantsByParticipantIds(ids: IntArray, eventId: number): Promise<ContestantBase[]> {
        return this.BaseFetchArray(
            ContestantBase,
            `Contestant/GetContestantsByParticipantIds` + '?' + (eventId == undefined ? '' : `eventId=${eventId}`),
            'POST',
            ids,
        );
    }
    public static async GetRaceContestantsWithContestantAndDeviceStatusByEvent(
        eventID: number,
        filter: TrackingFilterRequest,
    ): Promise<RaceContestantWithContestantAndDeviceStatus[]> {
        return this.BaseFetchArray(
            RaceContestantWithContestantAndDeviceStatus,
            `Contestant/RaceContestantsWithContestantAndDeviceStatus` + '?' + (eventID == undefined ? '' : `eventID=${eventID}`),
            'POST',
            filter,
        );
    }
    public static async GetRaceContestantsWithContestantAndDeviceStatusByContestantID(
        eventID: number,
        contestantID: number,
    ): Promise<RaceContestantWithContestantAndDeviceStatus[]> {
        return this.BaseFetchArray(
            RaceContestantWithContestantAndDeviceStatus,
            `Contestant/RaceContestantsWithContestantAndDeviceStatusByContestantID` +
                '?' +
                (eventID == undefined ? '' : `eventID=${eventID}`) +
                '&' +
                (contestantID == undefined ? '' : `contestantID=${contestantID}`),
            'GET',
        );
    }
    public static async GetContestantTimes(EventId: number, ContestantId: number): Promise<ContestantAndRaceContestantTime[]> {
        return this.BaseFetchArray(
            ContestantAndRaceContestantTime,
            `Contestant/GetContestantTimes` +
                '?' +
                (EventId == undefined ? '' : `EventId=${EventId}`) +
                '&' +
                (ContestantId == undefined ? '' : `ContestantId=${ContestantId}`),
            'GET',
        );
    }
    public static async ImportContestants(contestantImport: ContestantImport, EventID: number): Promise<ContestantImport | null> {
        return this.BaseFetch(
            ContestantImport,
            `Contestant/Import` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            contestantImport,
        );
    }
}
